// @flow
import * as React from 'react';
import { FormattedMessage, IntlShape, injectIntl } from 'react-intl';
import Attributes from 'esm-web-pro/components/layout/sidePanel/Attributes';
import points11Messages from 'esm-web-pro/messages/points11Messages';

type Props = {
    line: Object,
    intl: IntlShape,
}

const GisLinesAttributes = (props: Props) => {
    const { line, intl: { formatMessage } } = props;

    const {
        start_container_point: startContainerPoint, end_container_point: endContainerPoint, length,
    } = line;

    const attributes = [
        {
            label: <FormattedMessage id="map-object-provider-attribute" defaultMessage="Provider" />,
            value: line.infrastructure_provider.entity.name,
        },
        {
            label: <FormattedMessage id="map-object-ref" defaultMessage="Ref" />,
            value: line.ref,
        },
        {
            label: <FormattedMessage id="map-object-line-start" defaultMessage="Start" />,
            value: `${formatMessage(points11Messages[startContainerPoint.point?.type])} 
            ${line.start_container_point.sequence}`,
        },
        {
            label: <FormattedMessage id="map-object-line-end" defaultMessage="End" />,
            value: `${formatMessage(points11Messages[endContainerPoint?.point?.type])} 
            ${line.end_container_point.sequence}`,
        },
        {
            label: <FormattedMessage id="gisline-attributes-length" defaultMessage="Length" />,
            value: <FormattedMessage
                id="gisline-attributes-length-value"
                defaultMessage="{value} m. {test}"
                values={{ value: parseFloat(length)?.toFixed(2) }}
            />,
        },
    ];
    if (line.regions) {
        attributes.push(
            {
                label: (
                    <FormattedMessage
                        id="map-regions"
                        defaultMessage="Regions"
                    />
                ),
                multiValue: line.regions.map((region) => ({
                    value: region.name,
                    link: region.uuid ? `/infrastructure/map/${line.map}/${line.map_is_active
                        ? 'active' : 'draft'}/layer/region/${
                        region.uuid}` : null,
                })),
                separator: ', ',
            },
        );
    }

    return <Attributes attributes={attributes} />;
};

export default injectIntl(GisLinesAttributes);
